import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Import images (replace with your actual image paths)
import kundliImage from "../Assets/Images/section2-1.png";
import vastuImage from "../Assets/Images/section2-2.png";
import yagyaImage from "../Assets/Images/section2-3.png";

const AstrologyFeatures = () => {
 
  
  const features = [
    {
      title: "Kundli Analysis",
      description:
        "Gain deep insights into your life's journey with expert Kundli and Birth Chart Analysis by Pt. Kamlesh Sharma. Understand your destiny, strengths, and challenges.",
      image: kundliImage,
    },
    {
      title: "Vastu Consultation",
      description:
        "Enhance your living space and invite positive energies with Vastu consultation from Pt. Kamlesh Sharma. Create a harmonious environment for peace and prosperity.",
      image: vastuImage,
    },
    {
      title: "Mahamrityunjay Yagya",
      description:
        "Experience the powerful Vedic ritual performed by Pt. Kamlesh Sharma to invoke Lord Shiva’s blessings, overcome obstacles, and attain spiritual protection.",
      image: yagyaImage,
    },
  ];

  return (
    <div className="bg-black text-white py-12">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-8">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="border border-gray-600 p-6 rounded-lg text-center"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
            >
              <motion.img
                src={feature.image}
                alt={feature.title}
                className="mx-auto mb-4 w-20 h-20"
                initial={{ rotate: 0 }}
                animate={{ rotate: 360 }}
                transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
              />
              <h2 className="text-xl font-bold">{feature.title}</h2>
              <p className="text-gray-400 mt-2">{feature.description}</p>
              <Link to="/about" >
              <button
                className="mt-4 bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded"
              >
                Learn More
              </button>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AstrologyFeatures;
